// actions
export const FETCH_SIMULATIONS = 'simulations/FETCH_SIMULATIONS';
export const FETCH_SIMULATION = 'simulations/FETCH_SIMULATION';
export const ADD_SIMULATION = 'simulations/ADD_SIMULATION';
export const DOWNLOAD_STD_DEVS = 'simulations/DOWNLOAD_STD_DEVS';